export const API_URL = 'https://aihub-api.buso.asia';
